import React from "react";
import ConditionExpressionManager from './ConditionExpressionManager';
import Collapse from 'react-bootstrap/Collapse';
import BootstrapSwitchButton from 'bootstrap-switch-button-react';
import Badge from 'react-bootstrap/Badge';
import { RULE_TYPES } from  '../../shared/constants/app_constants';

export default class ConditionsTab extends React.Component{

  getNewConditionExpression(){
    return {
      index: undefined,
      id: undefined,
      _destroy: false,

      operand1_uuid: undefined, // are we using this anymore? I dont think so
      operand1_value_type: undefined,
      operator: undefined,
      operand2_pre_type: undefined
      // operand2 can take different forms
    };
  }

  /**
   * return an array of target attribute names
   */
  getTargetAttributeNames(){
    let targetAttributeNames = [];
    this.props.form_rule.target_attribute_ids.forEach(target_attribute_id => {
      const targetAttribute = this.props.keenform.form_attributes.find(fa => fa.id === target_attribute_id);
      targetAttributeNames.push(targetAttribute.name);
    });
    return targetAttributeNames;
  }

  updateConditionalOperand2PreType = () => { //TODO needs params, but what?
    console.log('under construction');
  }

  ruleTypeAction(){
    const form_rule = this.props.form_rule;
    let returnVal = ""
    switch (form_rule.rule_type){
      case RULE_TYPES.HIDING:
        returnVal = "hide";
        break;
      case RULE_TYPES.LOCKING:
        returnVal = "lock";
        break;
      case RULE_TYPES.VALUE_SETTING:
        returnVal = "set value";
        break;
      case RULE_TYPES.FILTERING:
        returnVal = "filter";
        break;
      case RULE_TYPES.VALIDATING:
        returnVal = "conditionally validate";
        break;
    }
    return returnVal;
  }

  setJoiner(joinerType){
    this.props.updateFormRuleAttributePerParams("nocode_condition_joiner", joinerType);
  }

  setUseConditionFunction(useConditionFunction) {
    this.props.updateFormRuleAttributePerParams("use_condition_function", useConditionFunction);
  }

  renderConditionDescription = () => {
    return (
      <p className="lead target-attribute-name-badges">
        <strong>
          {this.ruleTypeAction().toUpperCase() }
          &nbsp;
          {this.getTargetAttributeNames().map((name, index) => <Badge key={index} pill variant="light">{name}</Badge>)}&nbsp;
          <i>when</i>
        </strong>
      </p>
    );
  }

  renderConditionJoinerToggleButtons = () => {
    return (
      <Collapse in={this.props.form_rule.form_rule_conditionals.length > 1}>
        <div className={`col-md-4 text-right`}>
          <div className="btn-group" role="group" aria-label="form_rule_conditional_block_joiner">
            <button 
              type="button"
              onClick={() => {this.setJoiner('AND')}}
              className={`btn btn-outline-primary ${this.props.form_rule.nocode_condition_joiner === 'AND' ? 'active' : ''}`}>AND</button>
            <button 
              type="button"
              onClick={() => {this.setJoiner('OR')}}
              className={`btn btn-outline-primary ${this.props.form_rule.nocode_condition_joiner === 'OR' ? 'active' : ''}`}>OR</button>
          </div>
          <input 
            type="hidden" 
            name="form_rule[nocode_condition_joiner]" 
            value={this.props.form_rule.nocode_condition_joiner} />
        </div>
      </Collapse>
    )
  }

  // TODO: might need to refactor this - change the name to updateFormRuleConditionals
  updateConditionExpression = (conditional) => { //TODO: need to work on this
    let updatedConditional = {...conditional};

    // get copy of conditionExpressionList
    let formRuleConditionalsArray = [...this.props.form_rule.form_rule_conditionals];

    //get operand1 form attribute uuid
    const updatedFAUUID = updatedConditional.operand1_uuid;
    let formAttribute;
    if (updatedFAUUID !== undefined){
      formAttribute = this.props.keenform.form_attributes.find(fa => fa.uuid === updatedFAUUID);
    }

    const operand1Modified = formRuleConditionalsArray[updatedConditional.index].operand1_uuid !== updatedConditional.operand1_uuid;
    formRuleConditionalsArray[updatedConditional.index] = updatedConditional;
    
    this.props.updateFormRuleAttributePerParams("form_rule_conditionals", formRuleConditionalsArray);
  }

  renderConditionalSection = () => {
    const form_rule = this.props.form_rule,
    conditionals = form_rule.form_rule_conditionals.map((conditional, index) => {
      return {
        ...conditional,
        index
      }
    });
    const activeConditionalsCount = conditionals.filter(c => !c._destroy).length;

    return (
      <div>
        { this.renderUseConditionFunctionToggle() }
        { form_rule.use_condition_function
          ? this.renderCustomFunctionInput()
          : this.renderNoCodeConditionsInputs()
        }
      </div>
    );
  }

  renderCustomFunctionInput = () => {
    return (<div>
      <div>Input for custom condition function body</div>
      <div className="alert alert-warning">this is experimental feature - this input will convert into javascript embedded into a function. Code must return a boolean (TRUE/FALSE) value for the condition.</div>
      <div>this code with be used to create a lambda function that will pass a javascript object key/value hash</div>
      <div className="mock-function-container">
        <pre>(formAttributeValues) =&gt; &#123;</pre>
        <pre>// the following code will be used to create a javascript function</pre>
        <div className="m-3">
          <textarea 
            className="form-control crt-mock-code-input"
            rows="6"
            defaultValue={this.props.form_rule.condition_function_body} 
            name="form_rule[condition_function_body]"
            id="form_rule_condition_function_body"
            style={{'marginLeft':'-15px'}} />
        </div>
        <pre>&#125;</pre>
      </div>
    </div>);
  }

  renderNoCodeConditionsInputs = () => {
    const form_rule = this.props.form_rule,
    conditionals = form_rule.form_rule_conditionals.map((conditional, index) => {
      return {
        ...conditional,
        index
      }
    });
    const activeConditionalsCount = conditionals.filter(c => !c._destroy).length;
    return (          
      <div>        
        <div className="form-group row">
          <div className="col-md-8">
            {this.renderConditionDescription()}
          </div>
          {this.renderConditionJoinerToggleButtons()}
        </div>

        <div className="form-group row">
          <div className="col-12">
            <div className="condition-list">
              { conditionals.map((conditional, index) => {
                  const lastRow     = ( index === (conditionals.length-1)),
                      disableDelete = ( activeConditionalsCount === 1 || conditional._destroy),
                      rowClass      = ( conditional._destroy ? 'd-none' : 'row condition-item');
                  return (<React.Fragment key={`frag-${index}`}>
                    <div key={`condition-${index}`} className={rowClass}>
                      <div className="col-md-10">
                      <ConditionExpressionManager
                        conditional={conditional}
                        conditional_type="form_rule_conditional"
                        keenform={this.props.keenform}
                        form_rule={form_rule}
                        onUpdateAction={this.updateConditionExpression}
                        index={index} />
                      </div>
                      <div className="col-md-2 text-right">
                        <button
                          onClick={() => {this.props.deleteCondition(index)}}
                          className="btn btn-danger btn-circle"
                          disabled={disableDelete}
                          type="button">
                            <i className="fas fa-trash-alt"></i>
                        </button>
                      </div>
                    </div>
                    { lastRow ? undefined :
                      <div className="row">
                        <div className="col">
                          <span className="badge badge-info badge-pill">{this.props.form_rule.nocode_condition_joiner}</span>
                        </div>
                      </div>
                    }
                  </React.Fragment>);
                })
              }
            </div>
          </div>
        </div>

        <div className="row">
          <div className="col-6">
            invert condition: &nbsp;
            <BootstrapSwitchButton 
                onlabel='true' 
                offlabel='false'
                onstyle='success'
                width='100'
                size="lg"
                onChange={(checked) => {
                  this.props.updateFormRuleAttributePerParams("invert_condition", checked);
                }}
                checked={this.props.form_rule.invert_condition} />
            <input 
              type="hidden"
              name="form_rule[invert_condition]"
              value={this.props.form_rule.invert_condition === true ? "1" : "0"}
              />
          </div>
          <div className="col-6 text-right">
            <button
              onClick={() => {this.props.addNewCondition()}}
              className={`btn btn-success invisible'}`}
              disabled={!this.props.allConditionsAreValid}
              type="button">
                <i className="fa fa-plus"></i> ADD CONDITION
            </button>
          </div>
        </div>
        
      </div>
    );
  }

  renderUseConditionFunctionToggle = () => {
    return (
      <div className="row">
        <div className="col-6">
          No Code or Custom Function
          <BootstrapSwitchButton 
              onlabel='Conditional Function' 
              offlabel='No Code Conditions'
              onstyle='secondary'
              width='400'
              size="lg"
              onChange={(checked) => {
                this.setUseConditionFunction(checked);
              }}
              checked={this.props.form_rule.use_condition_function} />
          <input 
            type="hidden"
            name="form_rule[use_condition_function]"
            value={this.props.form_rule.use_condition_function === true ? "1" : "0"}
            />
        </div>
      </div>
     );
  }

  render(){
    const form_rule = this.props.form_rule,
    conditionals = form_rule.form_rule_conditionals.map((conditional, index) => {
      return {
        ...conditional,
        index
      }
    });
    const activeConditionalsCount = conditionals.filter(c => !c._destroy).length;
    return (
    <div className="container">
      <div className="form-group row">
        <div className="col">
          <div className="alert alert-info" role="alert">
            Conditions provides a way to add logic so that rules can run <i>conditionally</i>
          </div>
          { form_rule
            ? <React.Fragment>
                <span>Execute this rule </span>
                <BootstrapSwitchButton 
                  onlabel='Conditionally' 
                  offlabel='Always'
                  onstyle='info'
                  width='200'
                  size="lg"
                  onChange={(checked) => {
                    this.props.setUseConditionExpressionBlockFlag(checked);
                  }}
                  onUpdateAction={this.updateConditionExpression}
                  onUpdateConditionalOperand2PreType={this.updateConditionalOperand2PreType}
                  checked={this.props.form_rule.use_nocode_condition} />
              </React.Fragment>
              : undefined
          }
          <input 
            type="hidden"
            name="form_rule[use_nocode_condition]"
            value={this.props.form_rule.use_nocode_condition === true ? "1" : "0"}
            />
        </div>
      </div>
      { form_rule.use_nocode_condition && this.renderConditionalSection() }
    </div>);
  }
}